import { ConditionCode } from '@/shared/api/protocol-ts/model/dto_report_condition_codes_pb';

export const getAllowedConditionCodesKey = (
  toothType: ConditionCode,
  toothPosition: number,
) => `${toothType}:${toothPosition}`;
